export default __webpack_public_path__ + "static/barts-london-3c91127f01262ae786b659f6ae11b4f2.png";